import { InPlaceDropDownEditor } from "@etframework/ui.components";
import { useRef, useState } from "react";
import { TaskDetailTaxReturn } from "./TaskDetailTaxReturn";
import { useTaskTemplates } from "../../data/queries/taskTemplateQueries";
import { SkeletonComponent } from "@syncfusion/ej2-react-notifications";
import { useTranslation } from "react-i18next";

export const FormTaskTaxReturnDetail = ({
  ids,
  taskTemplate,
  onTaskModified,
  canModifyTasks,
  taskTypeId,
}) => {
  const { t } = useTranslation(["Overlay", "Shared"], {
    useSuspense: false,
  });
  const componentRef = useRef(null);
  const [showEditor, setShowEditor] = useState(!taskTemplate?.Deleted);
  const { data: taskTemplates, isPending: isTaskTemplatesPending } =
  useTaskTemplates(taskTypeId);
  
  const renderInPlaceEditor = () => {
    if (taskTemplate?.Deleted && !showEditor) {
      return (
        <div className="d-flex gap-3 align-items-center">
          <span>{taskTemplate?.Name}</span>
          <button
            className="btn et-blue"
            onClick={() => setShowEditor(true)}
            style={{ width: "10px" }}
          >
            <i className="fa-regular fa-pencil"></i>
          </button>
        </div>
      );
    }

    return (
      <InPlaceDropDownEditor
        ref={componentRef}
        id={ids.taxReturnInfo.template}
        dataSource={taskTemplates}
        fields={{ text: "Name", value: "Id" }}
        sortOrder="Descending"
        value={taskTemplate?.Deleted ? null : taskTemplate?.Id}
        disabled={!canModifyTasks}
        model={{ showClearButton: true }}
        emptyText={t("SelectForm")}
        actionSuccess={(e) => {
          e.id = ids.taxReturnInfo.template;
          onTaskModified(e);
        }}
      />
    );
  };

  return (
    <TaskDetailTaxReturn label={t("Form")} labelCss="ps-2">
      {isTaskTemplatesPending ? (
        <SkeletonComponent
          height={"1.5em"}
          className="my-1"
          width={"150px"}
          shimmerEffect="Fade"
        />
      ) : (
        renderInPlaceEditor()
      )}
    </TaskDetailTaxReturn>
  );
};
